import React from "react";
import { connect } from "react-redux";
import NavbarLinks from "./components/Links";
import ApplicationName from "components/app-name";

const PublicNavbar = ({routes, ...props}) => {
  return (
    <div className="frosted-glass px-3 sm:px-6 py-3 sm:py-2 sticky top-0 z-40 flex flex-row flex-wrap items-center shadow border-emerald-100/50">
      <div className="">
        <ApplicationName extra="flex flex-row items-center mx-auto max-w-[200px]" logoClass="logo-xs"/>
      </div>
      <nav className="flex flex-row flex-wrap items-center justify-end flex-grow">
          <NavbarLinks routes={routes.filter(route => route.isMainMenu)}/>
      </nav>
    </div>
  );
};

const mapStateToProps = (state) => ({
  	
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicNavbar);
